import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    user: null,
};

const mutations = {
    [type.SET_USER](state, user) {
        state.user = user;
    },
};

const getters = {
    user: state => {
        return state.user;
    },
};

const actions = {
    getUser({ commit }) {
        let route = Laroute.route('franchise.vue.auth_user');

        axios.get(route).then(res => commit(type.SET_USER, res.data));
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js